export default __webpack_public_path__ + "i18n/translation-bn.fd87f9a4.json";